import React from "react";

export type TableRowContextType = {
    showChild: boolean;
};

export type TableRowActionsContextType = {
    toggleShowChild: () => void;
};

export const TableRowContext = React.createContext<TableRowContextType>({
    showChild: false,
});

export const TableRowActionsContext = React.createContext<TableRowActionsContextType>({
    toggleShowChild: () => {},
});

export const useTableRowContext = () => React.useContext(TableRowContext);

export const useTableRowActionsContext = () => React.useContext(TableRowActionsContext);

type PropsType = {
    children: React.ReactNode;
};

export const TableRowContextProvider = ({ children }: PropsType) => {
    const [showChild, setShowChild] = React.useState<boolean>(false);

    const toggleShowChild = React.useCallback(() => {
        setShowChild((prevState) => !prevState);
    }, []);

    const tableRowContextValue: TableRowContextType = React.useMemo(
        () => ({ showChild }),
        [showChild]
    );

    const tableRowActionsContextValue: TableRowActionsContextType = React.useMemo(
        () => ({ toggleShowChild }),
        [toggleShowChild]
    );

    return (
        <TableRowContext.Provider value={tableRowContextValue}>
            <TableRowActionsContext.Provider value={tableRowActionsContextValue}>
                {children}
            </TableRowActionsContext.Provider>
        </TableRowContext.Provider>
    );
};
